import Axios from 'axios'
import { getPathName, getApiHash, getApiToken } from './helper';

const obtenerParametros = async ({rubro = "AUTO"}) => {

    const params = {
        hash: await getApiHash(),
        rubro
    }
    const headers = { 
        'content-type': 'application/json',
        "Authorization" : 'Bearer ' + await getApiToken()
    }
    return await Axios.post( await getPathName() + "/getparametroscotizacionjson", params,
        {
            headers: headers
        }).then(function (response) {
            return response;
        }).catch(function (error) {
            return error;
    });
};

export default obtenerParametros;